'use strict';
var foreach = require('./utils/foreach'),
    toObservable = require('./utils/observable');

/**
 * A store generator
 *
 * @param {object} opt
 * @constructor
 */
function Store(opt) {
    this._init(opt);
}

Store.prototype = {
    /**
     * The class intializer
     *
     * @param {object} opt
     * @private
     */
    _init: function (opt) {
        var _this = this;

        opt = opt || {};

        foreach(opt, function (value, prop) {
            _this[prop] = value;
        });

        toObservable(this);
        this.attributes = {};
    },
    /**
     *
     * @param {string} key
     * @param {*} val
     */
    set: function (key, val) {
        var _this = this,
            attrs;

        // Handle both `"key", value` and `{key: value}` -style arguments.
        if (typeof key === 'object') {
            attrs = key;
        } else {
            (attrs = {})[key] = val;
        }

        foreach(attrs, function (value, key) {
            _this.attributes[key] = value;
        });
    },

    /**
     *
     * @param {string} attr
     * @returns {*}
     */
    get: function (attr) {
        return this.attributes[attr];
    },

    /**
     *
     * @returns {Store.attributes}
     */
    getAttributes: function () {
        return this.attributes;
    }
};

module.exports = Store;
